import axios from "../../../../utils/axios-private";

export const getCustomers = () => {
  return {
    type: "GET_DROPDOWN_CUSTOMERS",
    payload: new Promise((resolve, reject) => {
      const controller = new AbortController();
      const url = `/pelanggan/list`;
      axios
        .post(url, {}, { signal: controller.signal })
        .then((response) => {
          resolve({ response });
        })
        .catch((error) => {
          controller.abort();
          reject(error);
        });
    }),
  };
};
